import * as utils from "./utils";
import metadata from "./metadata";

// Async imports based on options for partial functionalities support
const defaultOptions = {
  canvas: true,
  dataTypes: false,
  import: true,
  multiframe: true,
  pacs: false,
  series: false,
  store: undefined,
  toolsStyle: undefined,
  utils: false
};

export default async (Vue, options) => {
  options = { ...defaultOptions, ...options };

  // setup larvitar
  utils.setup(options.store, options.toolsStyle);

  // canvas component
  if (options.canvas) {
    Vue.component("dicom-canvas", () => import("./render/Canvas"));
    Vue.component("dicom-canvas-data", () => import("./render/CanvasData"));
  }

  if (options.dataTypes) {
    const dicomDataTypes = () => import("../data-types/dicom");
    dicomDataTypes().then(({ default: components }) => {
      Object.keys(components).forEach(key => {
        const name = key
          .split(/(?=[A-Z])/)
          .reduce((string, chunk) => `${string}-${chunk.toLowerCase()}`, "");
        Vue.component(`data-type${name}`, components[key]);
      });
    });
  }

  // import component
  if (options.import) {
    Vue.component("dicom-import", () => import("./import/Component"));
    Vue.component("dicom-import-modal", () => import("./import/Wrapper"));
  }

  // multiframe components
  if (options.multiframe) {
    Vue.component("dicom-cinematic-tool", () =>
      import("./multiframe/CinematicTool")
    );
  }

  // pacs component
  if (options.pacs) {
    Vue.component("dicom-pacs-import", () => import("./pacs/import/Component"));
    Vue.component("dicom-pacs-import-modal", () =>
      import("./pacs/import/Wrapper")
    );
  }

  // series components
  if (options.series) {
    Vue.component("dicom-series-summary", () => import("./sop/SeriesSummary"));
  }

  // expose utilities functions
  if (options.utils) {
    Vue.prototype.$dicom = { ...utils, metadataDictionary: metadata };
  }
};
